import React, { Suspense, useEffect } from 'react';
import {
  Router, Route, Switch, Redirect,
} from 'react-router-dom';
import './App.css';
import './components/TableComponent/TableComponent.scss';
import history from './history';
import { useAuth } from './auth';
import Callback from './auth/Callback';

const imageName = require('./assets/images/logos_rappi-mustache.svg');

const Login = React.lazy(() => import('./pages/Login'));

const Dashboard = React.lazy(() => import('./containers/Dashboard'));
const App = () => {
  const { renewSession } = useAuth();
  useEffect(() => {
    if (localStorage.getItem('isLoggedIn') === 'true') {
      renewSession();
    } else {
      history.push('/');
    }
  }, [renewSession]);

  return (
    <Router history={history}>
      <div className="App" id="app">
        <Suspense fallback={(
          <div style={{
            fontSize: 30, fontWeight: 'bold', color: '#2ecf62', paddingTop: '200px', textAlign: 'center', width: '100%', paddingBottom: '100px', background: '#eef1f5',
          }}
          >
            <img src={imageName} style={{ width: '200px' }} alt="Rappi" />
          </div>
          )}
        >
          <Route
            path="/"
            exact
            render={props => <Login {...props} />}
          />
          <Switch>
            <Route
              path="/dashboard"
              component={Dashboard}
            />
            <Route path="/callback" component={Callback} />

            <Redirect from="/dashboard/shoppers-table" to="/dashboard/management" />
          </Switch>
        </Suspense>
      </div>
    </Router>
  );
};

export default App;
